import { Button, Card, Col, DatePicker, message, Row, Select, Spin } from 'antd';
import gql from 'graphql-tag';
import html2canvas from 'html2canvas';
import { isNumber } from 'lodash';
import * as moment from 'moment';
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router';
import { client } from 'src/services/api';
import { QuerySkus } from 'src/types/sku';
import styled from 'styled-components';
import * as xlsx from 'xlsx';

import { selectTemplates, templatesList } from './courseTemplate';

const TbodyStyle = styled.tbody`
  width: 100%;
  border: 2px solid #333;
`;

const TrStyle = styled.tr`
  width: 100%;
  display: flex;
  flex-direction: row;
  border: none;
  border-top: 1px solid #ccc;
`;

const HeadTr = styled.tr`
  width: 100%;
  display: flex;
  flex-direction: row;
`;

const ThStyle = styled.th`
  width: 110px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  font-weight: bold;
  background-color: white;
  border-right: 1px solid #ccc;
`;

const TitleTh = styled(ThStyle)`
  flex: 1;
  min-width: 110px;
  border-right: none;
`;

const TdStyle = styled.td`
  flex: 1;
  min-width: 110px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  font-weight: bold;
  border-right: 1px solid #ccc;
  &:last-child {
    border-right: none;
  }
  background-color: #fca82d;
`;

const TdDate = styled.td`
  flex: 1;
  width: 60px;
  height: 72px;
  text-align: center;
  border-right: 1px solid #ccc;
  font-weight: bold;
  padding: 0;
  &:last-child {
    border-right: none;
  }
  display: flex;
  flex-direction: column;
`;

const ThDate = styled(TdDate)`
  flex: 0;
  width: 110px;
`;

const BlockSpan = styled.span`
  flex: 1;
  height: 32px;
  line-height: 32px;
`;
const SpanLesson = styled(BlockSpan)<{ isContainR: boolean }>`
  border-top: 1px solid #ccc;
  cursor: pointer;
  overflow: hidden;
  color: ${props => (props.isContainR ? `rgb(124, 0, 124)` : `rgb(217, 1, 13)`)};
`;

const SpanDateWithLesson = styled(BlockSpan)`
  background-color: #8ef2e7;
`;

const SpanDateWithoutLesson = styled(BlockSpan)`
  background-color: #fefee0;
`;

const DateSpan = styled(BlockSpan)`
  width: 110px;
`;
const LessonSpan = styled(DateSpan)`
  border-top: 1px solid #ccc;
`;

const TableCaption = styled.caption`
  caption-side: top;
  text-align: center;
  font-size: 30px;
  color: #333;
`;

export const SKU_FIELDS = gql`
  fragment skuFields on Sku {
    id
    start
    end
    name
    courseId
    schedules {
      serialId
      unlockAt
      prerequisites
      status
      groupIndex
      displayId
    }
    course {
      id
      name
      serialId
      lessons {
        id
        serialId
      }
    }
  }
`;

export const skuScheduleLessonQuery = gql`
  ${SKU_FIELDS}
  query getSkuListQuery($ids: [ID]) {
    skus(ids: $ids) {
      ...skuFields
    }
  }
`;

export const updateSchedulesMutation = gql`
  ${SKU_FIELDS}
  mutation updateSchedules($id: Int, $schedules: [ScheduleInput]) {
    updateSchedules(id: $id, schedules: $schedules) {
      ...skuFields
    }
  }
`;

const enum ScheduleDateType {
  START,
  END,
  FESTIVAL,
}
interface ScheduleSet {
  date: Date;
  type: ScheduleDateType;
}

interface Course {
  id: number;
  name: string;
  lessons: Lesson[];
  serialId: string;
}

interface Lesson {
  serialId: string;
  id: number;
  displayId: string;
  groupId: number;
}

interface RangeLesson {
  displayId?: string;
  serialId: string;
  unlockAt: string;
  date: string;
  prerequisites: string[];
  week: string;
  status?: number;
  groupIndex?: number;
}

export interface CourseData {
  courses: Course[];
}

enum LessonStatus {
  PLAYED = 4,
}

interface Lesson {
  serialId: string;
  id: number;
  displayId: string;
  name: string;
  groupId: number;
}

interface ScheduleType {
  serialId: string;
  displayId?: string;
  unlockAt: string;
  prerequisites: string[];
  status?: number;
  groupIndex?: number;
}

interface Props {}
interface State {
  scheduleSetList: ScheduleSet[];
  isShowSetModal: boolean;
  festivalList: string[];
  lessons: {
    serialId: number;
    id: number;
  }[];
  startDate: moment.Moment;
  courseStartDate: Date;
  rangeList: RangeLesson[][];
  courseName: string;
  courseSerialId: string;
  loading: boolean;
  scheduleList: ScheduleType[];
  templateList: string[];
  isEdit: boolean;
  skuName: string;
  exportImageLoading: boolean;
  tableCaption: string;
  courseDesc: string;
}

type AllProps = RouteComponentProps<{
  courseId: string;
  id: string;
}> &
  Props;

export class SetSchedules extends Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props);
    this.state = {
      scheduleSetList: [],
      isShowSetModal: false,
      festivalList: [],
      startDate: moment(new Date()),
      courseStartDate: new Date(),
      rangeList: [],
      courseName: '',
      loading: false,
      exportImageLoading: false,
      scheduleList: [],
      isEdit: false,
      templateList: [],
      lessons: [],
      skuName: '',
      tableCaption: '',
      courseDesc: '',
      courseSerialId: '',
    };
  }

  private rangeTemplate: ScheduleType[] = [];
  private freePart: ScheduleType[] = [];

  private festivalList: string[] = [];
  async componentWillMount() {
    const { id } = this.props.match.params;
    const res = await client.query<QuerySkus>({
      query: skuScheduleLessonQuery,
      variables: { ids: [id] },
    });
    const skus = (res.data && res.data.skus) || [];
    const [sku] = skus;
    if (!sku) {
      return;
    }
    const { schedules, course, name: skuname, start } = sku;
    const { name, lessons, serialId: courseSerialId } = course;
    if (schedules.length === 0) {
      this.setState({ courseSerialId, lessons, skuName: skuname, isEdit: true, courseName: name });
      return;
    }

    const schdelusFilterTypename = schedules.map(item => {
      const { unlockAt, prerequisites, serialId, displayId, status, groupIndex } = item;
      const schedule: ScheduleType = { unlockAt, prerequisites, serialId };
      if (displayId) {
        schedule.displayId = displayId;
      }
      if (isNumber(status)) {
        schedule.status = status;
      }
      if (isNumber(groupIndex)) {
        schedule.groupIndex = groupIndex;
      }
      return schedule;
    });
    this.filterPresentLesson(schdelusFilterTypename);

    const [startSchedule] = this.rangeTemplate;
    let startDate = moment(startSchedule.unlockAt);
    const startWeek = moment(startSchedule.unlockAt).format('ddd');
    switch (startWeek) {
      case '周二': {
        startDate = moment(startSchedule.unlockAt).subtract(1, 'days');
        break;
      }
      case '周三': {
        startDate = moment(startSchedule.unlockAt).subtract(2, 'days');
        break;
      }
      case '周四': {
        startDate = moment(startSchedule.unlockAt).subtract(3, 'days');
        break;
      }
      case '周五': {
        startDate = moment(startSchedule.unlockAt).subtract(4, 'days');
        break;
      }
      case '周六': {
        startDate = moment(startSchedule.unlockAt).subtract(5, 'days');
        break;
      }
      case '周日': {
        startDate = moment(startSchedule.unlockAt).subtract(6, 'days');
        break;
      }
    }

    const len = this.rangeTemplate.length - 1;
    let index = 0;
    let currentLen = len;
    let currentIndex = 0;
    const currentRangeList: RangeLesson[][] = [];
    while (currentLen >= 0) {
      const weekRange: RangeLesson[] = [];
      for (const week of this.weekList) {
        const baseDate = moment(startDate).add(index, 'days');
        const date = baseDate.format('ddd,YYYY-MM-DD').split(',')[1];
        const momentDate = baseDate.startOf('day').toISOString();
        let serialId = '';
        if (currentLen >= 0) {
          const schedules = this.rangeTemplate[currentIndex];
          const unlockAt = moment(schedules.unlockAt).format('YYYY-MM-DD');
          if (unlockAt === date) {
            serialId = schedules.serialId;
            currentIndex += 1;
            currentLen -= 1;
            weekRange.push({
              date,
              week,
              ...schedules,
            });
          } else {
            this.festivalList.push(date);
            weekRange.push({
              date,
              serialId,
              week,
              unlockAt: momentDate,
              prerequisites: [],
            });
          }
        } else {
          this.festivalList.push(date);
          weekRange.push({
            date,
            serialId,
            week,
            unlockAt: momentDate,
            prerequisites: [],
          });
        }
        index += 1;
      }
      currentRangeList.push(weekRange);
    }
    this.setTableCaptionAndCourseDesc(currentRangeList, courseSerialId, name, lessons, start);
    this.setState({
      lessons,
      startDate,
      courseSerialId,
      skuName: skuname,
      courseStartDate: start,
      rangeList: currentRangeList,
      courseName: name,
    });
  }

  setTableCaptionAndCourseDesc = (
    RangeLessionList: RangeLesson[][],
    courseSerialId: string,
    courseName: string,
    lessons: {
      serialId: number;
      id: number;
    }[],
    startDate: Date,
  ) => {
    const courseStartDate =
      RangeLessionList &&
      RangeLessionList.length > 0 &&
      RangeLessionList[0].length > 0 &&
      moment(startDate).format('MM.DD');
    const tableCaption = `聪明派|${courseName}【${courseStartDate}期排课表】`;

    // const LArray = this.rangeTemplate.filter(e => /^L/.test(e.serialId));
    // const EArray = this.rangeTemplate.filter(e => /^E/.test(e.serialId));
    // const RArray = this.rangeTemplate.filter(e => /^R/.test(e.serialId));
    // const courseDesc = `共${this.rangeTemplate.length}节课: ${LArray.length}节教学课【L系列】+ ${EArray.length}节匹配练习课【E系列】+ ${RArray.length}节主题复习课【R系列】`;
    const LArrayCount = /C3\d+/.test(courseSerialId) ? 80 : lessons.filter(e => /^L/.test(String(e.serialId))).length;
    const EArrayCount = /C3\d+/.test(courseSerialId) ? 80 : lessons.filter(e => /^E/.test(String(e.serialId))).length;
    const RArrayCount = lessons.filter(e => /^R/.test(String(e.serialId))).length;
    const courseDesc = `共${
      LArrayCount + EArrayCount + RArrayCount
    }节课: ${LArrayCount}节教学课【L系列】+ ${EArrayCount}节匹配练习课【E系列】+ ${RArrayCount}节主题复习课【R系列】`;

    this.setState({
      tableCaption,
      courseDesc,
    });
  };

  onSelectDate = (date: moment.Moment) => {
    this.setState({ startDate: date });
  };

  isFestival = (date: string) => {
    const festival = this.festivalList.find(festival => festival === date);
    if (festival) {
      return true;
    }
    return false;
  };

  private weekList = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];

  exportRangeImage = async () => {
    const { skuName } = this.state;

    this.setState({ exportImageLoading: true });

    // draw canvas from htmlElement
    const element = document.querySelector('#rangeTable') as HTMLElement;
    const canvas: HTMLCanvasElement = await html2canvas(element);

    // export image to local
    const link = document.getElementById('exportRangeImagelink') as HTMLElement;
    link.setAttribute('download', `排课表_${skuName}.png`);
    link.setAttribute('href', canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream'));
    link.click();

    this.setState({ exportImageLoading: false });
  };

  exportRangeExcel = () => {
    this.setState({ loading: true });
    const excelList: {
      星期?: string;
      周一?: string;
      周二?: string;
      周三?: string;
      周四?: string;
      周五?: string;
      周六?: string;
      周日?: string;
    }[] = [];
    const { rangeList, skuName } = this.state;
    for (const weekRange of rangeList) {
      const dateObj = {};
      const displayIdObj = {};
      dateObj['星期'] = '日期';
      displayIdObj['星期'] = '课次';
      for (const range of weekRange) {
        const week = range.week;
        switch (week) {
          case '周一': {
            dateObj['周一'] = range.date;
            displayIdObj['周一'] = range.displayId || range.serialId;
            break;
          }
          case '周二': {
            dateObj['周二'] = range.date;
            displayIdObj['周二'] = range.displayId || range.serialId;
            break;
          }
          case '周三': {
            dateObj['周三'] = range.date;
            displayIdObj['周三'] = range.displayId || range.serialId;
            break;
          }
          case '周四': {
            dateObj['周四'] = range.date;
            displayIdObj['周四'] = range.displayId || range.serialId;
            break;
          }
          case '周五': {
            dateObj['周五'] = range.date;
            displayIdObj['周五'] = range.displayId || range.serialId;
            break;
          }
          case '周六': {
            dateObj['周六'] = range.date;
            displayIdObj['周六'] = range.displayId || range.serialId;
            break;
          }
          case '周日': {
            dateObj['周日'] = range.date;
            displayIdObj['周日'] = range.displayId || range.serialId;
            break;
          }
        }
      }
      excelList.push(dateObj);
      excelList.push(displayIdObj);
    }
    const workbook = xlsx.utils.book_new();
    const rangeListExcel = xlsx.utils.json_to_sheet(excelList);
    xlsx.utils.book_append_sheet(workbook, rangeListExcel);
    xlsx.writeFile(workbook, `排课表_${skuName}.xlsx`);
    this.setState({ loading: false });
  };

  onTemplateChange = (value: number) => {
    const rangeTemplate: ScheduleType[] = templatesList[value];
    this.filterPresentLesson(rangeTemplate);
  };

  rangeUseTemplate = () => {
    const { startDate, courseName, lessons, courseSerialId, courseStartDate } = this.state;
    if (!startDate) {
      message.warning('请选择开课日期！');
      return;
    }
    if (moment(startDate).format('ddd') !== '周一') {
      message.warning('周一开课');
      return;
    }

    if (!this.rangeTemplate.length) {
      message.warning('请选择排课模版！');
    }

    let index = 0;
    let currentInd = 0;
    const len = this.rangeTemplate.length - 1;
    let currentIndex = len;
    const currentRangeList: RangeLesson[][] = [];
    const rangeTemplate: ScheduleType[] = [];

    while (currentIndex >= 0) {
      const weekRange: RangeLesson[] = [];
      for (const week of this.weekList) {
        const baseDate = moment(startDate).startOf('day').add(index, 'days');
        const [weekname, date] = baseDate.format('ddd,YYYY-MM-DD').split(',');
        if (currentIndex >= 0) {
          if (weekname !== '周五' && weekname !== '周六' && weekname !== '周日') {
            const schedule = this.rangeTemplate[currentInd];
            schedule.unlockAt = baseDate.utc().toISOString();
            weekRange.push({
              date,
              week,
              ...this.rangeTemplate[currentInd],
            });
            rangeTemplate.push(this.rangeTemplate[currentInd]);
            currentInd += 1;
            currentIndex -= 1;
          } else {
            weekRange.push({ date, week, serialId: '', unlockAt: '', prerequisites: [] });
            this.festivalList.push(date);
          }
        } else {
          if (weekname !== '周五' && weekname !== '周六' && weekname !== '周日') {
            weekRange.push({ date, week, serialId: '', unlockAt: '', prerequisites: [] });
          } else {
            weekRange.push({ date, week, serialId: '', unlockAt: '', prerequisites: [] });
            this.festivalList.push(date);
          }
        }
        index += 1;
      }
      currentRangeList.push(weekRange);
    }
    this.setTableCaptionAndCourseDesc(currentRangeList, courseSerialId, courseName, lessons, courseStartDate);
    this.setState({ rangeList: currentRangeList });
  };

  filterPresentLesson = (schedules: ScheduleType[]) => {
    const isHasRepeat = schedules.some(template => {
      if (template.status && template.status === LessonStatus.PLAYED) {
        return true;
      }
      return false;
    });

    if (isHasRepeat) {
      const filterTemplate = schedules.filter(template => template.status && template.status === LessonStatus.PLAYED);
      this.freePart = filterTemplate;
      this.rangeTemplate = schedules.filter(template => !template.status);
    } else {
      this.rangeTemplate = schedules;
    }
  };

  onSaveScheduleClick = () => {
    const { id } = this.props.match.params;
    let schedules: ScheduleType[] = [];
    if (this.freePart.length > 0) {
      const [firstSchedule] = this.rangeTemplate;
      this.freePart.forEach(schedule => (schedule.unlockAt = firstSchedule.unlockAt));
      schedules = [...this.freePart, ...this.rangeTemplate];
    } else {
      schedules = this.rangeTemplate;
    }
    client
      .mutate({
        mutation: updateSchedulesMutation,
        variables: { id, schedules },
      })
      .then(res => {
        if (res.data) {
          message.success('保存成功！');
          this.props.history.goBack();
        }
      })
      .catch(error => {
        const [err] = error.graphQLErrors;
        message.error(err.message);
      });
  };

  adjustLesson = (rowIndex: number, colIndex: number) => {
    const { rangeList, startDate } = this.state;
    const schedule = rangeList[rowIndex][colIndex];
    const { date } = schedule;
    const target = this.festivalList.findIndex(festival => festival === date);
    if (target > -1) {
      this.festivalList.splice(target, 1);
    } else {
      this.festivalList.push(date);
    }

    let index = 0;
    let currentInd = 0;
    const len = this.rangeTemplate.length - 1;
    let currentIndex = len;
    const currentRangeList: RangeLesson[][] = [];
    const rangeTemplate: ScheduleType[] = [];
    while (currentIndex >= 0) {
      const weekRange: RangeLesson[] = [];
      for (const week of this.weekList) {
        const baseDate = moment(startDate).startOf('day').add(index, 'days');
        const date = baseDate.format('ddd,YYYY-MM-DD').split(',')[1];
        const baseDateString = baseDate.utc().toISOString();
        if (currentIndex >= 0) {
          if (!this.isFestival(date)) {
            this.rangeTemplate[currentInd].unlockAt = baseDateString;
            weekRange.push({
              date,
              week,
              ...this.rangeTemplate[currentInd],
            });
            rangeTemplate.push(this.rangeTemplate[currentInd]);
            currentInd += 1;
            currentIndex -= 1;
          } else {
            weekRange.push({ date, week, serialId: '', unlockAt: '', prerequisites: [] });
          }
        } else {
          weekRange.push({ date, week, serialId: '', unlockAt: '', prerequisites: [] });
        }
        index += 1;
      }
      currentRangeList.push(weekRange);
    }
    this.rangeTemplate = rangeTemplate;
    this.setState({ rangeList: currentRangeList });
  };

  render() {
    const {
      rangeList,
      courseName,
      tableCaption,
      courseDesc,
      startDate,
      isEdit,
      loading,
      skuName,
      exportImageLoading,
    } = this.state;

    return (
      <Card title={`课程设置`}>
        <Row>
          <h2>{skuName}</h2>
          <h3>课程：{courseName}</h3>
        </Row>
        {isEdit && (
          <Row type="flex" justify="space-between">
            <Col span={16}>
              <Select placeholder="选择模版" style={{ width: 188 }} onChange={this.onTemplateChange}>
                {selectTemplates.map(template => {
                  return (
                    <Select.Option key={template.name} value={template.value}>
                      {template.name}
                    </Select.Option>
                  );
                })}
              </Select>
              <DatePicker onChange={this.onSelectDate} value={startDate} style={{ marginLeft: 5 }} />
              <Button type="primary" onClick={this.rangeUseTemplate} style={{ marginLeft: 5 }}>
                预排课
              </Button>
            </Col>
          </Row>
        )}

        <Row type="flex" justify="end" style={{ marginTop: 30 }}>
          <Button
            type="primary"
            onClick={this.exportRangeImage}
            style={{ marginRight: 5 }}
            loading={exportImageLoading}
          >
            导出图片
          </Button>
          <Button type="primary" onClick={this.exportRangeExcel} style={{ marginRight: 5 }} loading={loading}>
            导出课表
          </Button>
          <Button type="primary" onClick={this.onSaveScheduleClick}>
            保存排课
          </Button>
        </Row>
        <a id="exportRangeImagelink" />
        <Row id="rangeTable" style={{ marginTop: 10 }}>
          <Spin spinning={loading || exportImageLoading}>
            <table style={{ width: '100%' }}>
              <TableCaption>{tableCaption}</TableCaption>
              <TbodyStyle>
                <HeadTr>
                  <ThStyle>##</ThStyle>
                  <TitleTh>{courseDesc}</TitleTh>
                </HeadTr>
                <TrStyle>
                  <ThStyle>星期</ThStyle>
                  <TdStyle>周一</TdStyle>
                  <TdStyle>周二</TdStyle>
                  <TdStyle>周三</TdStyle>
                  <TdStyle>周四</TdStyle>
                  <TdStyle>周五</TdStyle>
                  <TdStyle>周六</TdStyle>
                  <TdStyle>周日</TdStyle>
                </TrStyle>
                {rangeList.map((listr, rowIndex) => {
                  return (
                    <TrStyle key={`keyIndex${rowIndex}`}>
                      <ThDate>
                        <DateSpan>日期</DateSpan>
                        <LessonSpan>课次</LessonSpan>
                      </ThDate>
                      {listr.map((item, colIndex) => {
                        return (
                          <TdDate key={`${rowIndex}-${colIndex}`}>
                            {item.serialId ? (
                              <SpanDateWithLesson>{item.date}</SpanDateWithLesson>
                            ) : (
                              <SpanDateWithoutLesson>{item.date}</SpanDateWithoutLesson>
                            )}
                            <SpanLesson
                              onClick={() => this.adjustLesson(rowIndex, colIndex)}
                              isContainR={(item.displayId && /^R/.test(item.displayId)) || /^R/.test(item.serialId)}
                              title={item.serialId ? `点击取消该日期下的排课` : `点击单元格添加课程`}
                              className={item.serialId ? 'spanWithData' : 'spanWithoutData'}
                            >
                              {item.displayId || item.serialId}
                            </SpanLesson>
                          </TdDate>
                        );
                      })}
                    </TrStyle>
                  );
                })}
              </TbodyStyle>
            </table>
          </Spin>
        </Row>
        <Row type="flex" justify="end" style={{ marginTop: 10 }}>
          <Button type="primary" onClick={this.props.history.goBack}>
            返回
          </Button>
        </Row>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/stock/SetSchedules.tsx